import React from 'react';
import PropTypes from 'prop-types';
import { Routes, Route, Link } from 'react-router-dom';
import isMobile from 'is-mobile';
import { StyledLink } from './components/util';
import { useResources } from './connect/hooks';

const Header = ({ showRegister = false }) => {
  const mobile = isMobile();
  const { texts } = useResources();
  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        maxWidth: '1080px',
        padding: '15px 10px 40px',
        alignItems: 'center',
        boxSizing: 'border-box',
      }}
    >
      <a
        href="https://www.twnel.com/"
        style={{
          display: 'flex',
          width: mobile ? '38px' : 'auto',
          overflow: 'hidden',
        }}
      >
        <img
          height="36"
          srcSet="
            https://twnelpublic.s3-us-west-2.amazonaws.com/Twnel_logo_colors%40320.png,
            https://twnelpublic.s3-us-west-2.amazonaws.com/Twnel_logo_colors%40640.png 2x,
            https://twnelpublic.s3-us-west-2.amazonaws.com/Twnel_logo_colors%401024.png 3x,
            https://twnelpublic.s3-us-west-2.amazonaws.com/Twnel_logo_colors%401280.png 4x,
          "
          src="https://twnelpublic.s3-us-west-2.amazonaws.com/Twnel_logo_colors%40320.png"
          alt="Twnel"
        />
      </a>
      <div style={{ flexGrow: 1 }} />
      <Routes>
        <Route
          path="/register"
          element={(
            <StyledLink as={Link} to="/">
              {texts('Manage your business')}
            </StyledLink>
          )}
        />
        {showRegister ? (
          <Route
            path="*"
            element={(
              <StyledLink as={Link} to="/register">
                {texts('Create a free account')}
              </StyledLink>
            )}
          />
        ) : null}
      </Routes>
    </div>
  );
};

Header.propTypes = {
  showRegister: PropTypes.bool,
};

export default Header;
